import React, { useEffect } from 'react';

const SeoMetaogImage = ({ ogImage }) => {
  useEffect(() => {
    const setOrUpdateMeta = (attr, value) => {
      if (!value) return;

      const selector = `meta[property="${attr}"]`;
      let element = document.querySelector(selector);

      if (element) {
        element.setAttribute('content', value);
      } else {
        element = document.createElement('meta');
        element.setAttribute('property', attr);
        element.setAttribute('content', value);
        document.head.appendChild(element);
      }
    };

    const removeDuplicateMeta = (attr) => {
      const selector = `meta[property="${attr}"]`;
      const elements = document.querySelectorAll(selector);
      elements.forEach((el, i) => {
        if (i > 0) el.remove();
      });
    };

    // Clean up duplicates
    removeDuplicateMeta('og:image');

    // Set og:image
    setOrUpdateMeta('og:image', ogImage);
  }, [ogImage]);

  return null;
};

export default SeoMetaogImage;
